import React, { lazy } from "react";

const SaleReportDialog = lazy(() => import("./SaleReportDialog"));

export default function SaleReportLink({ item, form, text }) {
	const [modalIsOpen, setModalIsOpen] = React.useState(false);

	const showModal = () => setModalIsOpen(true);
	const closeModal = () => setModalIsOpen(false);

	return (
		<>
			<span className="sale-report-link" onClick={showModal}>
				{text || "Report Sale"}
			</span>
			{modalIsOpen && (<SaleReportDialog item={item} form={form} open={modalIsOpen} onClose={closeModal} />)}
		</>
	);
}